import { Grid } from '@mui/material'

export const PageActions: React.FC<{ children: React.ReactNode | React.ReactNode[] }> = ({ children }) => {
  return <Grid item>{children}</Grid>
}
